import { Suspense } from "react";

import Dim from "@/components/shared/ui/Dim/Dim";
import Loader from "@/components/shared/ui/Loader/Loader";
import { setDealTypeDisplayName } from "@utils/returnDealTypeDisplayName/returnDealTypeDisplayName";

import Pagination from "./components/Pagination/Pagination";
import PublicationListTable from "./components/PublicationListTable/PublicationListTable";
import PublicationListTableFilter from "./components/PublicationListTableFilter/PublicationListTableFilter";
import { useSetScrollPosition } from "./hooks/useSetScrollPosition";
import * as S from "./PublicationListContainer.style";

const PublicationListContainer = () => {
  useSetScrollPosition();
  setDealTypeDisplayName();

  return (
    <S.PressListWrapper>
      <Suspense
        fallback={
          <Dim>
            <Loader />
          </Dim>
        }
      >
        <PublicationListTableFilter />
        <PublicationListTable />
        <Pagination />
      </Suspense>
    </S.PressListWrapper>
  );
};

export default PublicationListContainer;
